import React, { useState } from "react";
import axios from "../../axios";
import { useSelector } from "react-redux";

import styles from "./AddComment.module.scss";

import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";

export const Index = ({ postId }) => {
  const [text, setText] = useState("");
  const { data } = useSelector((state) => state.auth);

  const handleSubmit = async () => {
    try {
      const fields = { text };
      await axios.post(`/comment/${postId}`, fields);
      setText("");
      window.location.reload(); // Или лучше обновление через состояние
    } catch (err) {
      console.warn(err);
      alert("Помилка під час створення коментаря");
    }
  };
  return (
    <>
      <div className={styles.root}>
        <Avatar
          classes={{ root: styles.avatar }}
          src={data.avatarUrl}
        />
        <div className={styles.form}>
          <TextField
            value={text}
            onChange={(e) => setText(e.target.value)}
            label="Написати коментар"
            variant="outlined"
            maxRows={10}
            multiline
            fullWidth
          />
          <Button onClick={handleSubmit} variant="contained">
            Отправить
          </Button>
        </div>
      </div>
    </>
  );
};
